export const jobMegaMenuData: Record<string, any> = {
  Tech: {
    left: [
      { key: 'all', label: 'All roles' },
      { key: 'engineering', label: 'Engineering' },
      { key: 'data', label: 'Data' },
      { key: 'product', label: 'Product' },
      { key: 'design', label: 'Design' },
      { key: 'it', label: 'IT & Security' },
    ],
    rightByKey: {
      all: [
        {
          title: 'Popular',
          items: [
            { label: 'Software Engineer' },
            { label: 'Frontend Developer' },
            { label: 'Backend Developer' },
            { label: 'Full‑Stack Developer' },
            { label: 'DevOps Engineer' },
            { label: 'QA Engineer' },
          ],
        },
      ],
      engineering: [
        {
          title: 'Engineering',
          items: [
            { label: 'Frontend Developer' },
            { label: 'Backend Developer' },
            { label: 'Full‑Stack Developer' },
            { label: 'Mobile Developer' },
            { label: 'DevOps / SRE' },
            { label: 'QA / Test Automation' },
          ],
        },
      ],
      data: [
        {
          title: 'Data',
          items: [
            { label: 'Data Scientist' },
            { label: 'Data Engineer' },
            { label: 'Analytics Engineer' },
            { label: 'ML Engineer' },
            { label: 'BI Analyst' },
          ],
        },
      ],
      product: [
        {
          title: 'Product',
          items: [
            { label: 'Product Manager' },
            { label: 'Product Owner' },
            { label: 'Scrum Master' },
          ],
        },
      ],
      design: [
        {
          title: 'Design',
          items: [
            { label: 'UX Designer' },
            { label: 'UI Designer' },
            { label: 'UX Researcher' },
            { label: 'Product Designer' },
          ],
        },
      ],
      it: [
        {
          title: 'IT & Security',
          items: [
            { label: 'IT Support' },
            { label: 'Systems Administrator' },
            { label: 'Network Engineer' },
            { label: 'Security Analyst' },
          ],
        },
      ],
    },
  },
  Healthcare: {
    left: [
      { key: 'all', label: 'All roles' },
      { key: 'nursing', label: 'Nursing' },
      { key: 'physicians', label: 'Physicians' },
      { key: 'allied', label: 'Allied Health' },
      { key: 'admin', label: 'Administration' },
    ],
    rightByKey: {
      nursing: [
        {
          title: 'Nursing',
          items: [
            { label: 'RN' },
            { label: 'LPN/LVN' },
            { label: 'Nurse Practitioner' },
            { label: 'Travel Nurse' },
          ],
        },
      ],
      physicians: [
        {
          title: 'Physicians',
          items: [{ label: 'Primary Care' }, { label: 'Hospitalist' }, { label: 'Specialist' }],
        },
      ],
      allied: [
        {
          title: 'Allied Health',
          items: [
            { label: 'Radiology' },
            { label: 'Respiratory Therapist' },
            { label: 'Physical Therapist' },
            { label: 'Pharmacy Tech' },
          ],
        },
      ],
      admin: [
        {
          title: 'Administration',
          items: [{ label: 'Medical Assistant' }, { label: 'Scheduler' }, { label: 'Billing & Coding' }],
        },
      ],
    },
  },
  Finance: {
    left: [
      { key: 'all', label: 'All roles' },
      { key: 'accounting', label: 'Accounting' },
      { key: 'banking', label: 'Banking' },
      { key: 'investments', label: 'Investments' },
      { key: 'insurance', label: 'Insurance' },
    ],
    rightByKey: {
      accounting: [
        { title: 'Accounting', items: [{ label: 'Staff Accountant' }, { label: 'Financial Analyst' }, { label: 'Controller' }, { label: 'Payroll' }] },
      ],
      banking: [{ title: 'Banking', items: [{ label: 'Teller' }, { label: 'Loan Officer' }, { label: 'Branch Manager' }] }],
      investments: [{ title: 'Investments', items: [{ label: 'Equity Research' }, { label: 'Portfolio Analyst' }, { label: 'Trader' }] }],
      insurance: [{ title: 'Insurance', items: [{ label: 'Claims' }, { label: 'Underwriting' }, { label: 'Actuarial' }] }],
    },
  },
  Education: {
    left: [
      { key: 'all', label: 'All roles' },
      { key: 'teaching', label: 'Teaching' },
      { key: 'support', label: 'Student Support' },
      { key: 'admin', label: 'Administration' },
    ],
    rightByKey: {
      teaching: [{ title: 'Teaching', items: [{ label: 'Elementary' }, { label: 'Secondary' }, { label: 'Higher Ed' }, { label: 'Special Education' }] }],
      support: [{ title: 'Student Support', items: [{ label: 'Counselor' }, { label: 'Librarian' }, { label: 'Coach' }] }],
      admin: [{ title: 'Administration', items: [{ label: 'Principal' }, { label: 'Registrar' }, { label: 'Admissions' }] }],
    },
  },
  'Sales & Marketing': {
    left: [
      { key: 'all', label: 'All roles' },
      { key: 'sales', label: 'Sales' },
      { key: 'marketing', label: 'Marketing' },
      { key: 'cs', label: 'Customer Success' },
      { key: 'support', label: 'Support' },
    ],
    rightByKey: {
      sales: [{ title: 'Sales', items: [{ label: 'SDR/BDR' }, { label: 'Account Executive' }, { label: 'Sales Manager' }, { label: 'Sales Ops' }] }],
      marketing: [{ title: 'Marketing', items: [{ label: 'Growth Marketing' }, { label: 'Content Marketing' }, { label: 'SEO' }, { label: 'Brand Marketing' }] }],
      cs: [{ title: 'Customer Success', items: [{ label: 'CSM' }, { label: 'Implementation' }, { label: 'Renewals' }] }],
      support: [{ title: 'Support', items: [{ label: 'Support Specialist' }, { label: 'Help Desk' }, { label: 'Escalations' }] }],
    },
  },
  Ausbildung: {
    left: [
      { key: 'all', label: 'Alle Bereiche' },
      { key: 'kaufmaennisch', label: 'Kaufmännisch' },
      { key: 'technik', label: 'Technik' },
      { key: 'gesundheit', label: 'Gesundheit' },
      { key: 'it', label: 'IT' },
    ],
    rightByKey: {
      kaufmaennisch: [{ title: 'Kaufmännisch', items: [{ label: 'Industriekaufmann/-frau' }, { label: 'Bankkaufmann/-frau' }, { label: 'Kaufmann/-frau im Einzelhandel' }] }],
      technik: [{ title: 'Technik', items: [{ label: 'Mechatroniker/in' }, { label: 'Elektroniker/in' }, { label: 'Industriemechaniker/in' }] }],
      gesundheit: [{ title: 'Gesundheit', items: [{ label: 'Pflegefachkraft' }, { label: 'Physiotherapie' }, { label: 'MFA' }] }],
      it: [{ title: 'IT', items: [{ label: 'Fachinformatiker/in' }, { label: 'IT-Systemkaufmann/-frau' }, { label: 'Anwendungsentwicklung' }] }],
    },
  },

  // Industries used by the job navigation bar (top-level categories)
  'IT & Telekommunikation': {
    left: [
      { key: 'all', label: 'Alle anzeigen' },
      { key: 'entwicklung', label: 'Softwareentwicklung' },
      { key: 'data', label: 'Daten & KI' },
      { key: 'cloud', label: 'Cloud & DevOps' },
      { key: 'security', label: 'IT-Sicherheit' },
    ],
    rightByKey: {
      all: [{ title: 'IT & Telekommunikation', items: [{ label: 'Softwareentwickler/in' }, { label: 'DevOps Engineer' }, { label: 'Cloud Engineer' }, { label: 'Data Engineer' }, { label: 'IT-Security' }] }],
      entwicklung: [{ title: 'Softwareentwicklung', items: [{ label: 'Frontend' }, { label: 'Backend' }, { label: 'Full‑Stack' }, { label: 'Mobile' }] }],
      data: [{ title: 'Daten & KI', items: [{ label: 'Data Scientist' }, { label: 'ML Engineer' }, { label: 'Analytics' }] }],
      cloud: [{ title: 'Cloud & DevOps', items: [{ label: 'Kubernetes' }, { label: 'CI/CD' }, { label: 'SRE' }] }],
      security: [{ title: 'IT-Sicherheit', items: [{ label: 'SOC' }, { label: 'Pentest' }, { label: 'GRC' }] }],
    },
  },
  'Ingenieurwesen & Technik': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Ingenieurwesen & Technik', items: [{ label: 'Maschinenbau' }, { label: 'Elektrotechnik' }, { label: 'Automatisierung' }, { label: 'Qualität' }] }] },
  },
  'Finanzen & Versicherung': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Finanzen & Versicherung', items: [{ label: 'Buchhaltung' }, { label: 'Controlling' }, { label: 'Bankwesen' }, { label: 'Versicherung' }] }] },
  },
  'Bildung & Erziehung': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Bildung & Erziehung', items: [{ label: 'Lehre' }, { label: 'Hochschule' }, { label: 'Kita' }, { label: 'Verwaltung' }] }] },
  },
  'Sozialer Sektor & Pflege': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Sozialer Sektor & Pflege', items: [{ label: 'Pflege' }, { label: 'Erziehung' }, { label: 'Sozialarbeit' }] }] },
  },
  'Büroarbeit & Verwaltung': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Büroarbeit & Verwaltung', items: [{ label: 'Assistenz' }, { label: 'Sachbearbeitung' }, { label: 'Office Management' }] }] },
  },
  'Vertrieb, Einkauf & Verkauf': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Vertrieb, Einkauf & Verkauf', items: [{ label: 'Sales' }, { label: 'Key Account' }, { label: 'Einkauf' }, { label: 'Retail' }] }] },
  },
  'Kundenservice & Call Center': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Kundenservice & Call Center', items: [{ label: 'Inbound' }, { label: 'Outbound' }, { label: 'Helpdesk' }] }] },
  },
  'Gastronomie & Tourismus': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Gastronomie & Tourismus', items: [{ label: 'Küche' }, { label: 'Service' }, { label: 'Hotel' }, { label: 'Reise' }] }] },
  },
  'Bau, Handwerk & Produktion': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Bau, Handwerk & Produktion', items: [{ label: 'Handwerk' }, { label: 'Produktion' }, { label: 'Instandhaltung' }] }] },
  },
  'Transport, Logistik & Verkehr': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Transport, Logistik & Verkehr', items: [{ label: 'Fahrer/in' }, { label: 'Lager' }, { label: 'Dispo' }] }] },
  },
  Immobilien: {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Immobilien', items: [{ label: 'Verwaltung' }, { label: 'Makler' }, { label: 'Facility' }] }] },
  },
  'Architektur & Bau': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Architektur & Bau', items: [{ label: 'Architektur' }, { label: 'Bauleitung' }, { label: 'Planung' }] }] },
  },
  'Chemie & Pharma': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Chemie & Pharma', items: [{ label: 'Labor' }, { label: 'Produktion' }, { label: 'Regulatory' }] }] },
  },
  'Energie & Umwelt': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Energie & Umwelt', items: [{ label: 'Erneuerbare' }, { label: 'Versorgung' }, { label: 'Umwelt' }] }] },
  },
  'Öffentlicher Dienst & Non-Profit': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Öffentlicher Dienst & Non-Profit', items: [{ label: 'Behörden' }, { label: 'Verwaltung' }, { label: 'NGO' }] }] },
  },
  'Medien, PR & Kommunikation': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Medien, PR & Kommunikation', items: [{ label: 'PR' }, { label: 'Social Media' }, { label: 'Content' }] }] },
  },
  'Kunst & Kultur': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Kunst & Kultur', items: [{ label: 'Kultur' }, { label: 'Museen' }, { label: 'Theater' }] }] },
  },
  'Landwirtschaft & Tierhaltung': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Landwirtschaft & Tierhaltung', items: [{ label: 'Landwirtschaft' }, { label: 'Forst' }, { label: 'Tierhaltung' }] }] },
  },
  'Mini- & Nebenjobs': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Mini- & Nebenjobs', items: [{ label: 'Aushilfe' }, { label: 'Werkstudent' }, { label: 'Ferienjob' }] }] },
  },
  Praktika: {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Praktika', items: [{ label: 'Pflichtpraktikum' }, { label: 'Freiwillig' }, { label: 'Volontariat' }] }] },
  },
  'Weitere Jobs': {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Weitere Jobs', items: [{ label: 'HR' }, { label: 'Recht' }, { label: 'Sonstiges' }] }] },
  },

  default: {
    left: [{ key: 'all', label: 'Alle anzeigen' }],
    rightByKey: { all: [{ title: 'Jobs', items: [] }] },
  },
};
